import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  InputAdornment,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { verifyUser } from "../../API/API";
import {
  handleOpenContactUs,
  handleOpenPrivacyPolicy,
  handleOpenTermsOfService,
  showToast,
} from "../../components/common/Util/Util";
import EmailIcon from "@mui/icons-material/Email";
import PersonIcon from "@mui/icons-material/Person";
import CallIcon from "@mui/icons-material/Call";
import LoginIcon from "@mui/icons-material/Login";
const RegisterUser = ({
  showRegister,
  setShowRegister,
  setShowLoginScreen,
  setShowOTPVarification,
  setRequestData,
  setShowMobileOTP,
  requestData,
}) => {
  const ip = useSelector((state) => state.user.ip);
  const cordinates = useSelector((state) => state.user.cordinates);
  const [isLoading, setIsLoading] = useState(false);
  const inputRef = useRef(null);
  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    if (requestData?.mobileNumber) {
      setValue(
        "mobileNumber",
        requestData?.mobileNumber?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")
      );
    }
  }, []);
  // Autofocus using ref on mount
  useEffect(() => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 200);
  }, []);

  const onSubmit = (data) => {
    setIsLoading(true);
    const registerRequest = {
      name: data?.name,
      mobileNumber: data?.mobileNumber?.replace(/-/g, ""),
      email: data?.email,
      // userType: USER_TYPES.BORROWER,
      ip: ip,
      longitude: String(cordinates?.lng ? cordinates?.lng : ""),
      latitude: String(cordinates?.lat ? cordinates?.lat : ""),
      screen: "create",
      continueAs: requestData.continueAs, // Default
    };
    setRequestData(registerRequest);
    verifyUser(registerRequest)
      .then((res) => {
        setIsLoading(false);
        if (res?.statusCode === 200) {
          showToast(res.message, "success");
          setShowOTPVarification(true);
          setShowMobileOTP(false);
          handleClose();
        } else if (
          res?.statusCode === 208 &&
          res?.message === "User Already Exist!!"
        ) {
          showToast(res?.message, "error");
          setShowLoginScreen(true);
          handleClose();
        } else if (
          res?.statusCode === 208 &&
          res?.message === "Email and Mobile belong to different users!!"
        ) {
          setShowLoginScreen(false);
          showToast(res?.message, "error");
        } else if (
          res?.statusCode === 208 &&
          res?.message === "Email Already Exist!!"
        ) {
          setShowLoginScreen(false);
          showToast(res?.message, "error");
        } else if (
          res?.statusCode === 208 &&
          res?.message === "Mobile Number Already Exist!!"
        ) {
          setShowLoginScreen(false);
          showToast(res?.message, "error");
        } else {
          showToast("Oops! Something went wrong.", "error");
          setShowLoginScreen(false);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        console.error(e);
        showToast("Oops! Something went wrong.", "error");
        setIsLoading(false);
      });
  };

  const handleClose = () => {
    setIsLoading(false);
    setShowRegister(false);
  };

  return (
    <Dialog
      open={showRegister}
      onClose={isLoading ? null : handleClose}
      maxWidth="lg"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "20px",
          overflow: "hidden",
        },
      }}
    >
      <DialogContent sx={{ padding: 0, position: "relative" }}>
        {!isLoading && (
          <CloseIcon
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              cursor: "pointer",
              zIndex: 2,
            }}
          />
        )}
        <Grid container sx={{ height: "100%" }}>
          {/* Left Side Image (Merged with Border) */}
          <Grid
            item
            xs={12}
            sm={5}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: `url('/fintech.png') center/cover no-repeat`,
            }}
          />

          {/* Right Side Form */}
          <Grid
            item
            xs={12}
            sm={7}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              padding: "3rem",
              position: "relative",
            }}
          >
            {isLoading && (
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.7)",
                  zIndex: 10,
                }}
              >
                <CircularProgress size={60} sx={{ color: "#003A91" }} />
                <Typography
                  variant="h6"
                  sx={{ ml: 2, color: "#003A91", fontWeight: "bold" }}
                >
                  Processing...
                </Typography>
              </Box>
            )}

            {/* Logo at Top Center */}
            <Box sx={{ textAlign: "center", mb: 3 }}>
              <img
                src="/dequiLogo.png"
                alt="Logo"
                style={{ width: "150px" }}
              />
            </Box>
            <Typography variant="h6" fontWeight={700} color="#003A91">
              Hello! Register to get started
            </Typography>
            <Typography
              sx={{
                color: "#555",
                fontSize: "0.9rem",
                fontStyle: "italic",
                mb: 2,
              }}
            >
              To get started, create a new account by providing your details.
            </Typography>

            <Controller
              name="name"
              control={control}
              rules={{
                required: "Name is required",
                minLength: {
                  value: 2,
                  message: "Name must be at least 2 characters",
                },
                maxLength: {
                  value: 50,
                  message: "Name must not exceed 50 characters",
                },
                pattern: {
                  value: /^[A-Za-z\s]+$/,
                  message: "Name should only contain letters and spaces",
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  inputRef={inputRef}
                  label={
                    <>
                      Name
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  fullWidth
                  margin="dense"
                  slotProps={{
                    inputLabel: { shrink: true },
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <PersonIcon />
                        </InputAdornment>
                      ),
                    },
                  }}
                  error={!!errors?.name}
                  helperText={errors?.name?.message}
                  disabled={isLoading}
                  onInput={(e) => {
                    const cleaned = e.target.value
                      .replace(/^\s+/, "") // Remove leading spaces
                      .replace(/[^a-zA-Z.' ]/g, ""); // Allow only letters, dot, apostrophe, space
                    e.target.value = cleaned;
                    field.onChange(cleaned); // Update form state correctly
                  }}
                  placeholder="Enter your name"
                />
              )}
            />
            <Controller
              name="mobileNumber"
              control={control}
              rules={{
                required: "Mobile number is required",
                validate: (value) => {
                  const digitsOnly = value.replace(/\D/g, "");
                  return (
                    digitsOnly.length === 10 ||
                    "Mobile number must be 10 digits"
                  );
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  label={
                    <>
                      Mobile Number
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  type="tel"
                  slotProps={{
                    htmlInput: {
                      maxLength: 10,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    },
                    inputLabel: { shrink: true },
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          {/* <CallIcon sx={{ color: "#004AAD" }} /> */}
                          <CallIcon />
                        </InputAdornment>
                      ),
                    },
                  }}
                  onInput={(e) => {
                    e.target.value.replace(/^\s+/, "");
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    e.target.value = e.target.value.replace(
                      /(\d{3})(\d{3})(\d{4})/,
                      "$1-$2-$3"
                    );
                    field.onChange(e);
                  }}
                  onPaste={(e) => {
                    e.preventDefault(); // ❌ Block paste
                  }}
                  sx={{ mb: "1rem" }}
                  error={!!errors?.mobileNumber}
                  placeholder="XXX-XXX-XXXX"
                  helperText={errors?.mobileNumber?.message}
                />
              )}
            />
            <Controller
              name="email"
              control={control}
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid email address",
                },
                maxLength: {
                  value: 100,
                  message: "Email must not exceed 100 characters",
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label={
                    <>
                      Email
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  fullWidth
                  margin="dense"
                  error={!!errors?.email}
                  slotProps={{
                    inputLabel: { shrink: true },
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon />
                        </InputAdornment>
                      ),
                    },
                  }}
                  helperText={errors?.email?.message}
                  disabled={isLoading}
                  onInput={(e) => {
                    e.target.value.replace(/^\s+/, "");
                    e.target.value = e.target.value.replace(/^\s+/, "");
                  }}
                  placeholder="Enter your email ID"
                />
              )}
            />
            <Button
              variant="contained"
              fullWidth
              sx={{
                mt: 2,
                backgroundColor: "#003A91",
                "&:hover": { backgroundColor: "#002570" },
              }}
              onClick={handleSubmit(onSubmit)}
              disabled={isLoading}
              startIcon={<LoginIcon />} // Icon added here
            >
              {isLoading ? (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <CircularProgress size={24} sx={{ color: "white", mr: 1 }} />
                  Registering...
                </Box>
              ) : (
                "Continue"
              )}
            </Button>

            <Typography sx={{ mt: 2, textAlign: "center", fontSize: "0.9rem" }}>
              Already have an account?{" "}
              <Link
                onClick={() => {
                  if (!isLoading) {
                    handleClose();
                    setShowLoginScreen(true);
                  }
                }}
                sx={{
                  fontWeight: "bold",
                  color: "#003A91",
                  cursor: isLoading ? "default" : "pointer",
                  pointerEvents: isLoading ? "none" : "auto",
                }}
              >
                Sign In
              </Link>
            </Typography>

            {/* reCAPTCHA Disclaimer */}
            <Typography
              sx={{
                textAlign: "center",
                fontSize: "0.8rem",
                color: "#777",
                mt: "1rem",
              }}
            >
              This site is protected by reCAPTCHA and the{" "}
              <Link onClick={handleOpenPrivacyPolicy}>Privacy Policy</Link> and{" "}
              <Link onClick={handleOpenTermsOfService}>Terms of Service</Link>{" "}
              apply. For more info,{" "}
              <Link onClick={handleOpenContactUs}>Contact Us</Link>.
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default RegisterUser;
